import { render, staticRenderFns } from "./EditContactPage.vue?vue&type=template&id=57a8b285&scoped=true&"
import script from "./EditContactPage.vue?vue&type=script&lang=js&"
export * from "./EditContactPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a8b285",
  null
  
)

export default component.exports